<template>
  <b-container>
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">Water Data</div>
    <b-button size="sm" @click="requestDownload()" v-if="admin">
      Export Water Data Simple
    </b-button>
    <ag-grid-vue style="width: 100%; height: 500px;"
                 class="ag-theme-balham"
                 :columnDefs="this.waterColumnDefs"
                 :rowData="this.waterRowData">
    </ag-grid-vue>
  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import {FileUtils} from "@/lib/FileUtils";
import {
  isAdmin,
  isAdminClass,
  isAdminOrCertifier,
  isAdminVineyardAdminOrCertifier,
  isCertifier,
  isNonCertifierAdmin,
  isPureAdmin,
  isVineyardAdmin,
  isVineyardAdminMeth
} from "@/lib/UserUtils";

export default {
  name: "VineyardSimpleWaterMetricTable",
  props: {groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      waterColumnDefs: null,
      waterRowData: [],
      rowStyle1: {fontWeight: 'bold'},
      theGroupId: this.groupId,
      admin: isAdmin()
    }
  },
  beforeMount() {
    this.waterColumnDefs = [
      {
        headerName: 'Month', field: 'meterUsage', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Gallons Irrigation Water',
        field: 'irrigation',
        valueParser: this.numberParser,
        editable: false
      },
      {
        headerName: 'Gallons Frost Water',
        field: 'frost',
        valueParser: this.numberParser,
        editable: false
      },
      {
        headerName: 'Gallons Other',
        field: 'other',
        valueParser: this.numberParser,
        editable: false
      },
      {
        headerName: 'Gallons Other 2 ',
        field: 'other2',
        valueParser: this.numberParser,
        editable: false
      }
    ];
    console.log(`The admin value: ${this.admin}`)
    let theGroup = this.theGroupId;
    let self = this;
    this.$http.get("metrics/vineyard/water/graph/full/" + theGroup)
        .then(resultWater => {

          self.waterRowData = resultWater.data;
        }).catch(
        error => {
          console.log(error)
        });
  },
  methods: {
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/water/vineyard`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
  }
}
</script>

<style scoped>

</style>
